var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconRejectedEurOrder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3032",
    "data-name": "Path 3032",
    d: "M9.35,32.3a22,22,0,1,0,22-22,22,22,0,0,0-22,22",
    transform: "translate(-9.35 -10.305)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_eur-rejected",
    transform: "translate(-19 -477)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_267",
    "data-name": "Ellipse 267",
    transform: "translate(20 478)",
    fill: "#fff",
    stroke: "#3bb0ff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 22,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 22.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4312",
    "data-name": "Group 4312",
    transform: "translate(20 478)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2035",
    "data-name": "Rectangle 2035",
    width: 52.367,
    height: 52.751,
    transform: "translate(-4.084 -4.502)",
    fill: "#00237c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3020",
    "data-name": "Path 3020",
    d: "M56.22,15.753l.675,2.076h2.183l-1.766,1.283.674,2.077L56.22,19.906l-1.766,1.283.674-2.077-1.766-1.283h2.183Z",
    transform: "translate(-34.136 -13.373)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3021",
    "data-name": "Path 3021",
    d: "M56.22,92.557l.675,2.077h2.183l-1.766,1.283.674,2.077L56.22,96.71l-1.766,1.283.674-2.077-1.766-1.283h2.183Z",
    transform: "translate(-34.136 -56.626)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3022",
    "data-name": "Path 3022",
    d: "M94.691,54.283l.674,2.076h2.183l-1.766,1.283.675,2.077-1.767-1.283-1.766,1.283.674-2.077-1.766-1.283h2.183Z",
    transform: "translate(-55.801 -35.072)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3023",
    "data-name": "Path 3023",
    d: "M17.818,54.154l.674,2.077h2.183l-1.766,1.283.674,2.077-1.766-1.284-1.766,1.284.675-2.077L14.96,56.231h2.183Z",
    transform: "translate(-12.509 -34.999)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3024",
    "data-name": "Path 3024",
    d: "M22.937,34.7l.675,2.076H25.8l-1.767,1.283.675,2.077L22.937,38.85l-1.766,1.283.674-2.077L20.08,36.774h2.183Z",
    transform: "translate(-15.392 -24.042)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3025",
    "data-name": "Path 3025",
    d: "M36.635,20.617l.674,2.077h2.184l-1.767,1.283.674,2.077-1.766-1.283-1.767,1.283.675-2.077-1.767-1.283H35.96Z",
    transform: "translate(-23.106 -16.112)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3026",
    "data-name": "Path 3026",
    d: "M88.862,34.7l.675,2.076H91.72l-1.766,1.283.674,2.077L88.862,38.85,87.1,40.134l.674-2.077L86,36.774h2.183Z",
    transform: "translate(-52.518 -24.042)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3027",
    "data-name": "Path 3027",
    d: "M75.036,20.617l.674,2.077h2.184l-1.767,1.283.674,2.077-1.766-1.283L73.27,26.053l.675-2.077-1.767-1.283h2.184Z",
    transform: "translate(-44.732 -16.112)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3028",
    "data-name": "Path 3028",
    d: "M22.937,73.1l.675,2.077H25.8l-1.767,1.283.675,2.076-1.767-1.283-1.766,1.283.674-2.076L20.08,75.176h2.183Z",
    transform: "translate(-15.392 -45.668)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3029",
    "data-name": "Path 3029",
    d: "M36.635,86.8l.674,2.077h2.184l-1.767,1.283.674,2.076-1.766-1.283-1.767,1.283.675-2.076-1.767-1.283H35.96Z",
    transform: "translate(-23.106 -53.382)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3030",
    "data-name": "Path 3030",
    d: "M88.862,73.1l.675,2.077H91.72l-1.766,1.283.674,2.076-1.766-1.283L87.1,78.535l.674-2.076L86,75.176h2.183Z",
    transform: "translate(-52.518 -45.668)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3031",
    "data-name": "Path 3031",
    d: "M75.036,86.8l.674,2.077h2.184l-1.767,1.283.674,2.076-1.766-1.283L73.27,92.232l.675-2.076-1.767-1.283h2.184Z",
    transform: "translate(-44.732 -53.382)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4581",
    "data-name": "Group 4581",
    transform: "translate(1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_251",
    "data-name": "Ellipse 251",
    transform: "translate(47 506)",
    fill: "#ff7b7b",
    stroke: "#1d3960",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "plus",
    transform: "translate(42.261 514) rotate(-45)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_332",
    "data-name": "Line 332",
    y2: 8,
    transform: "translate(9.008 5.008)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_333",
    "data-name": "Line 333",
    x2: 8,
    transform: "translate(5.008 9.008)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRejectedEurOrder);
export default __webpack_public_path__ + "static/media/icon_rejected_eur_order.dba6316c2d891e47d2011a864a5b1226.svg";
export { ForwardRef as ReactComponent };